import React from 'react'
import ReactDOM from 'react-dom'
import PartnerCarousel from '../../../site/layout/component/PartnerCarousel'
import ThemeContext from '../../../site/layout/component/Theme/ThemeContext'

const debug = require('debug')('partnerCarousel')

export default () => {
  debug('init')
  document.addEventListener('DOMContentLoaded', () => {
    const theme = document.querySelector('body').dataset.theme

    document.querySelectorAll('.js-partner-carousel').forEach(appNode => {
      const props = JSON.parse(appNode.getAttribute('data-props') || '{}')
      ReactDOM.render(
        <ThemeContext.Provider value={theme}>
          <PartnerCarousel {...props} />
        </ThemeContext.Provider>,
        appNode
      )
    })
  })
}
